Object.defineProperty(exports,"__esModule",{value:true});var _pick2=require("lodash/pick");var _pick3=_interopRequireDefault(_pick2);var _flatten2=require("lodash/flatten");var _flatten3=_interopRequireDefault(_flatten2);var _isArray2=require("lodash/isArray");var _isArray3=_interopRequireDefault(_isArray2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _omit2=require("lodash/omit");var _omit3=_interopRequireDefault(_omit2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);
var _victoryCore=require("victory-core");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}exports.default=

{
getBaseProps:function getBaseProps(props,fallbackProps){
props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"errorbar");var _getCalculatedValues=
this.getCalculatedValues(props,fallbackProps),data=_getCalculatedValues.data,style=_getCalculatedValues.style,scale=_getCalculatedValues.scale,domain=_getCalculatedValues.domain;var _props=
props,groupComponent=_props.groupComponent,height=_props.height,width=_props.width,borderWidth=_props.borderWidth,standalone=_props.standalone;
var childProps={parent:{
domain:domain,style:style.parent,scale:scale,data:data,height:height,width:width,standalone:standalone}};

for(var index=0,len=data.length;index<len;index++){
var datum=data[index];
var eventKey=datum.eventKey||index;
var x=scale.x(datum._x1!==undefined?datum._x1:datum._x);
var y=scale.y(datum._y1!==undefined?datum._y1:datum._y);

var dataProps={
x:x,y:y,scale:scale,datum:datum,data:data,index:index,groupComponent:groupComponent,borderWidth:borderWidth,
style:this.getDataStyles(datum,style.data),
errorX:this.getErrors(datum,scale,"x"),
errorY:this.getErrors(datum,scale,"y")};


childProps[eventKey]={
data:dataProps};

var text=this.getLabelText(props,datum,index);
if(text!==undefined&&text!==null||props.events||props.sharedEvents){
childProps[eventKey].labels=this.getLabelProps(dataProps,text,style);
}
}
return childProps;
},

getLabelProps:function getLabelProps(dataProps,text,calculatedStyle){var
x=dataProps.x,index=dataProps.index,scale=dataProps.scale,errorY=dataProps.errorY;
var error=errorY&&Array.isArray(errorY)?errorY[0]:errorY;
var y=error||dataProps.y;
var labelStyle=this.getLabelStyle(calculatedStyle.labels,dataProps)||{};
return{
style:labelStyle,
y:y-(labelStyle.padding||0),
x:x,
text:text,
index:index,
scale:scale,
datum:dataProps.datum,
data:dataProps.data,
textAnchor:labelStyle.textAnchor,
verticalAnchor:labelStyle.verticalAnchor||"end",
angle:labelStyle.angle};

},

getErrorData:function getErrorData(props){
if(props.data){
if(props.data.length<1){
_victoryCore.Log.warn("This is an empty dataset.");
return[];
}

return this.formatErrorData(props.data,props);
}else{
var generatedData=(props.errorX||props.errorY)&&this.generateData(props);
return this.formatErrorData(generatedData,props);
}
},

getErrors:function getErrors(datum,scale,axis){







var errorNames={x:"errorX",y:"errorY"};
var errors=datum[errorNames[axis]];
if(errors===0){
return false;
}

return(0,_isArray3.default)(errors)?
[errors[0]===0?false:scale[axis](errors[0]+datum["_"+axis]),
errors[1]===0?false:scale[axis](datum["_"+axis]-errors[1])]:
[scale[axis](errors+datum["_"+axis]),scale[axis](datum["_"+axis]-errors)];
},

formatErrorData:function formatErrorData(dataset,props){
if(!dataset){
return[];
}
var accessor={
x:_victoryCore.Helpers.createAccessor(props.x!==undefined?props.x:"x"),
y:_victoryCore.Helpers.createAccessor(props.y!==undefined?props.y:"y"),
errorX:_victoryCore.Helpers.createAccessor(props.errorX!==undefined?props.errorX:"errorX"),
errorY:_victoryCore.Helpers.createAccessor(props.errorY!==undefined?props.errorY:"errorY")};


var replaceNegatives=function replaceNegatives(errors){

var replaceNeg=function replaceNeg(val){return!val||val<0?0:val;};
return(0,_isArray3.default)(errors)?errors.map(function(err){return replaceNeg(err);}):replaceNeg(errors);
};

var stringMap={
x:_victoryCore.Data.createStringMap(props,"x"),
y:_victoryCore.Data.createStringMap(props,"y")};


return dataset.map(function(datum,index){
var evaluatedX=accessor.x(datum);
var evaluatedY=accessor.y(datum);
var _x=evaluatedX!==undefined?evaluatedX:index;
var _y=evaluatedY!==undefined?evaluatedY:datum;
var errorX=replaceNegatives(accessor.errorX(datum));
var errorY=replaceNegatives(accessor.errorY(datum));

return(0,_assign3.default)(
{},
datum,
{_x:_x,_y:_y,errorX:errorX,errorY:errorY},

typeof _x==="string"?{_x:stringMap.x[_x],x:_x}:{},
typeof _y==="string"?{_y:stringMap.y[_y],y:_y}:{});

});
},

getDomain:function getDomain(props,axis){
var propsDomain=_victoryCore.Domain.getDomainFromProps(props,axis);
if(propsDomain){
return _victoryCore.Domain.padDomain(propsDomain,props,axis);
}
var categoryDomain=_victoryCore.Domain.getDomainFromCategories(props,axis);
if(categoryDomain){
return _victoryCore.Domain.padDomain(categoryDomain,props,axis);
}
var dataset=this.getErrorData(props);

if(dataset.length<1){
return _victoryCore.Scale.getBaseScale(props,axis).domain();
}

var domain=this.getDomainFromData(props,axis,dataset);
return _victoryCore.Domain.cleanDomain(_victoryCore.Domain.padDomain(domain,props,axis),props);
},

getDomainFromData:function getDomainFromData(props,axis,dataset){
var currentAxis=_victoryCore.Helpers.getCurrentAxis(axis,props.horizontal);
var error=void 0;
if(currentAxis==="x"){
error="errorX";
}else if(currentAxis==="y"){
error="errorY";
}
var axisData=(0,_flatten3.default)(dataset).map(function(datum){return datum["_"+currentAxis];});
var errorData=(0,_flatten3.default)((0,_flatten3.default)(dataset).map(function(datum){
var errorMax=void 0;
var errorMin=void 0;
if((0,_isArray3.default)(datum[error])){
errorMax=datum[error][0]+datum["_"+currentAxis];
errorMin=datum["_"+currentAxis]-datum[error][1];
}else{
errorMax=datum[error]+datum["_"+currentAxis];
errorMin=datum["_"+currentAxis]-datum[error];
}
return[errorMax,errorMin];
}));

var allData=axisData.concat(errorData);
var min=Math.min.apply(Math,_toConsumableArray(allData));
var max=Math.max.apply(Math,_toConsumableArray(allData));


if(min===max){
var adjustedMax=max===0?1:max;
return[0,adjustedMax];
}
return[min,max];
},

getCalculatedValues:function getCalculatedValues(props){
var defaultStyles=props.theme&&props.theme.errorbar&&props.theme.errorbar.style?
props.theme.errorbar.style:{};
var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%")||{};
var dataWithErrors=(0,_assign3.default)(_victoryCore.Data.getData(props),this.getErrorData(props));
var data=_victoryCore.Data.addEventKeys(props,dataWithErrors);
var range={
x:_victoryCore.Helpers.getRange(props,"x"),
y:_victoryCore.Helpers.getRange(props,"y")};

var domain={
x:this.getDomain(props,"x"),
y:this.getDomain(props,"y")};

var scale={
x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};


return{domain:domain,data:data,scale:scale,style:style};
},

getDataStyles:function getDataStyles(datum,style){
var stylesFromData=(0,_omit3.default)(datum,[
"x","y","name","errorX","errorY","eventKey"]);

return(0,_defaults3.default)({},stylesFromData,style);
},

getLabelText:function getLabelText(props,datum,index){
return datum.label||Array.isArray(props.labels)?
props.labels[index]:props.labels;
},

getLabelStyle:function getLabelStyle(labelStyle,dataProps){
labelStyle=labelStyle||{};var
size=dataProps.size,style=dataProps.style;
var matchedStyle=(0,_pick3.default)(style,["opacity","fill"]);
var padding=labelStyle.padding||size*0.25;
return(0,_defaults3.default)({},labelStyle,matchedStyle,{padding:padding})||{};
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/victory-errorbar/helper-methods.js
// module id = 1394
// module chunks = 0